module.exports = __webpack_public_path__ + "static/media/TallCabinet_Before.acf76358.jpg";